import React from 'react';

import { ListSearchFilterTypes, ListSearchFilterCustomProps, ListSearchFilterSelectSingleProps } from '@pixel/core/ListBase';
import SearchFilterAsyncUserAutoComplete from '../../SearchFilterAsyncUserAutoComplete';

export const statusFilter: ListSearchFilterSelectSingleProps = {
    id: "statusFilter",
    label: "Status",
    type: "single_select",
    placeholder: 'Select Status',
    options: [
      {value: "active", label: "Active"},
      {value: "inactive", label: "Inactive"},
    ]
}

export const createdByFitler: ListSearchFilterCustomProps = {
    id:"createdByFilter",
    label: "Created By",
    placeholder: 'Select Employee',
    type: ListSearchFilterTypes.Custom,
    renderCustomFilterCallback: SearchFilterAsyncUserAutoComplete
}
